import { BasicAuthenticationClient } from '@frontend/authentication-v2';
import { ICONS } from '@frontend/icons';
import { User } from '@frontend/user/utils';

import { useAppDispatch, useAppSelector } from '../redux/store';
import { endUserSession } from '../redux/terminal-navigation-slice';

const HomeLoggedInFooter = () => {
    const dispatch = useAppDispatch();
    const navigationState = useAppSelector((store) => store.navigation);
    const userData = navigationState.user;
    const user = userData?.user ? new User(userData.user) : null;

    const logout = () => {
        if (navigationState.user?.auth.jwt_token) {
            BasicAuthenticationClient.logout(navigationState.user.auth.jwt_token);
        }
        dispatch(endUserSession());
    };

    if (userData == null || user == null) {
        return null;
    }

    return (
        <div className='flex w-full gap-3'>
            <div className='bg-background-surface flex w-full items-center justify-between rounded-2xl p-3'>
                <div className='text-foreground-default flex flex-col'>
                    <p className='font-semibold'>{user.getDisplayName()}</p>
                </div>
                <div className='bg-brand-secondary flex size-9 items-center justify-center rounded-full'>
                    <div className='text-background-surface font-semibold'>{user.getInitials()}</div>
                </div>
            </div>
            <div
                data-testid='logout-user'
                onClick={logout}
                className='bg-background-surface text-brand-muted flex size-16 shrink-0 items-center justify-center rounded-2xl p-5'>
                {<ICONS.BUTTON.LOGOUT size='100%' />}
            </div>
        </div>
    );
};

export default HomeLoggedInFooter;
